    <ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index;">
            <li app-menuitem *ngIf="!item.separator" 
                [item]="item" 
                [index]="i" 
                [root]="true"
                [ngClass]="{'disabled': !isAccept}"
                >
            </li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul>
    <!-- <div class="text-center text-white layout-menu-text sidebar-footer-text" style="font-size: 8px;">
        VERSION 1.0.0
    </div> -->
